<template>
  <section class="content-current section-header">
    <div class="card-sendanyway">
      <p style="margin-top: 15px">افزایش اعتبار با موفقیت انجام گردید</p>
    </div>
    <div class="card-header">
      <h4>
        <span>مبلغ اعتبار: </span>
        <span
          style="
            color: rgb(93 177 34);
            font-weight: 600;
            text-align: center;
            font-size: 20px;
          "
          >{{ deposit | numFormat | rial }}</span
        >
      </h4>
    </div>

    <hr />
    <div class="btn-align"></div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      deposit: "",
    };
  },
  created() {
    this.deposit = this.$route.params.deposit;
    this.$store.commit("SetSumDeposit", this.deposit);
  },
  methods: {},
};
</script>

<style scoped>
.content-current {
  min-height: 300px;
}
.section-header {
  margin-top: 60px;
  margin-bottom: 60px;
}
.card-header {
  padding: 4.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #f3fbfe;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  text-align: center;
}
.btn-profile {
  width: 220px;
}
.btn-align {
  clear: both;
  text-align: center;
  margin: 35px;
}
.card-sendanyway {
  padding: 0.1rem 1.25rem;
  margin-bottom: 0;
  background-color: rgb(42, 105, 177) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  color: #fff;
  margin-top: 20px !important;
  font-size: 16px;
  width: 100%;
  text-align: center;
  border-radius: 3px;
}
</style>